export default {"src":"/login-app/[GIT_HASH]/_next/static/media/target.ebb6a5fc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};